import { render, staticRenderFns } from "./SupportLink.vue?vue&type=template&id=49682256&"
import script from "./SupportLink.vue?vue&type=script&lang=js&"
export * from "./SupportLink.vue?vue&type=script&lang=js&"
import style0 from "./SupportLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports